<header
  class="flex flex-col gap-0 bg-white lg:h-20 h-auto lg:px-26 px-0 py-4 p-4 sticky top-0 z-1000 w-full border-b border-[#ededee]"
>
  <div
    class="flex items-center justify-between flex-nowrap gap-2 lg:px-0 px-5"
  >
    <!-- logo and dropdown start  -->
    <div class="flex items-center lg:gap-8 gap-3 shrink-0">
      <a routerLink="/">
        <img
          src="../../../../../assets/theme/images/logo/NavBar.svg"
          width="45"
          height="45"
          class=""
          alt="Creative Stall"
        />
      </a>
      <div class="relative" #dropdownContainer>
        <!-- Explore Button -->
        <div
          role="button"
          tabindex="0"
          class="flex items-center gap-1.5 cursor-pointer"
          (click)="toggleDropdown('exploreMenu', $event)"
          (mouseenter)="warmExploreMenu()"
          (focus)="warmExploreMenu()"
          (touchstart)="warmExploreMenu()"
          (keydown)="onMenuKeydown($event, 'exploreMenu')"
          [attr.aria-expanded]="isDropdownVisible('exploreMenu')"
          aria-haspopup="true"
          aria-controls="explore-menu-panel"
        >
          <p class="font-medium text-base leading-5">Explore</p>
          <img
            src="../../../../../assets/header/icons/arrow-down.svg"
            alt="arrow-down icon"
            aria-hidden="true"
            class="transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isDropdownVisible('exploreMenu') }"
          />
        </div>
        <!-- Dropdown -->
        <div
          id="explore-menu-panel"
          class="xl:absolute fixed top-37.5 xl:top-14 left-0 border border-[#EFEFF1] bg-white xl:rounded-2xl rounded-none overflow-y-hidden xl:w-237.5 w-full shadow-lg z-40"
          [ngClass]="
            isDropdownVisible('exploreMenu')
              ? 'opacity-100 translate-y-0 visible'
              : 'opacity-0 -translate-y-2 invisible'
          "
          (mouseleave)="hoveredCategory = 'Animations'"
        >
          <div
            class="flex w-full xl:max-h-120 xl:min-h-120 overflow-y-auto xl:p-4 px-5 py-4"
          >
            <!-- Left: Categories -->
            <div class="xl:w-1/2 w-full xl:pe-4 pe-0">
              <h3
                class="font-medium text-base leading-7 text-themeCharcoal mb-5 uppercase"
              >
                Categories
              </h3>
              <!-- Dynamic Items Menu -->
              @for (item of categories; track $index) {
                @if (item.parentID === -1) {
                  <a
                    [routerLink]="getPackGalleryPath(item)"
                    (click)="onCategoryClick(item)"
                    class="category-item"
                    (mouseenter)="hoveredCategory = item.menuName ?? null"
                  >
                    <!-- <img [src]="'../../../../../assets/header/icons/' + (item.menuName ?? 'default') + '.svg'" alt="">
                -->
                    <img
                      [src]="
                        item.icon
                          ? appendBlobSasToken(item.icon, null)
                          : '../../../../../assets/header/placeholder.png'
                      "
                      alt="icon image"
                    />
                    <div>
                      <span class="category-title">{{ item.menuName }}</span>
                      <p class="category-desc">{{ item.shortDescription }}</p>
                    </div>
                  </a>
                }
              }
            </div>
            <!-- Right: Preview Images -->
            <div
              class="xl:w-1/2 xl:block hidden ps-4 border-l border-[#EFEFF1]"
            >
              <div class="h-full">
                <!-- Mount the preview (Lottie player + animation file) only once the menu is used, not on every page load. -->
                @if (exploreMenuWarm || isDropdownVisible('exploreMenu')) {
                @for (item of categories; track $index) {
                  @if (
                    item.parentID === -1 &&
                    hoveredCategory === (item.menuName ?? null)
                  ) {
                    <!-- <img [src]="'../../../../../assets/header/'
               + (item.menuName ?? 'default')
               + (item.menuName === 'Animations' ? '.gif' : '.png')" [alt]="item.menuName" class="menu-side-image"> -->
                    @if(item.iconNavigation?.endsWith('.json')){
                        <app-lottie-card
                          [filepath]="appendBlobSasToken(item.iconNavigation, null)"
                          [alwaysPlay]="true"
                          [defaultHeight]="false"
                          class="md:w-[70%] w-[65%]"
                        ></app-lottie-card>
                    }
                    @else {

                      <img
                       [src]="
                         item.iconNavigation
                           ? appendBlobSasToken(item.iconNavigation, null)
                           : '../../../../../assets/header/placeholder.png'
                       "
                       [alt]="item.menuName"
                       class="menu-side-image"
                     />
                    }
                  }
                }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="relative"> -->
        <!-- Tools Button -->
        <!-- <div
          role="button"
          tabindex="0"
          class="flex items-center gap-1.5 cursor-pointer"
          (click)="toggleDropdown('toolsMenu', $event)"
          (keydown)="onMenuKeydown($event, 'toolsMenu')"
          [attr.aria-expanded]="isDropdownVisible('toolsMenu')"
          aria-haspopup="true"
          aria-controls="tools-menu-panel"
        >
          <p class="font-medium text-base leading-5">Tools</p>
          <img
            src="../../../../../assets/header/icons/arrow-down.svg"
            alt="arrow-down icon"
            aria-hidden="true"
            class="transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isDropdownVisible('toolsMenu') }"
          />
        </div> -->
        <!-- Tools Dropdown -->
        <!-- <div
          id="tools-menu-panel"
          class="xl:absolute fixed top-37.5 xl:top-14 left-0 border border-[#EFEFF1] bg-white xl:rounded-2xl rounded-none xl:w-175 w-full max-h-[calc(100vh-150px)] overflow-y-auto shadow-lg z-40"
          [ngClass]="
            isDropdownVisible('toolsMenu')
              ? 'opacity-100 translate-y-0 visible'
              : 'opacity-0 -translate-y-2 invisible'
          "
        >
          <div class="xl:p-4 px-5 py-4">
            <h3
              class="font-medium text-base leading-7 text-themeCharcoal mb-2 uppercase"
            >
              Tools
            </h3>
            <div class="grid grid-cols-1 xl:grid-cols-2 xl:gap-x-2">
              @for (tool of tools; track tool.path) {
                <a
                  [routerLink]="tool.path"
                  (click)="onLinkClick($event)"
                  class="category-item"
                >
                  <div>
                    <span class="category-title">{{ tool.name }}</span>
                    <p class="category-desc">{{ tool.description }}</p>
                  </div>
                </a>
              }
            </div>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <!-- logo and dropdown end  -->

    <!------- Header Search Start (desktop): always mounted so logo/profile don't jump ------->
    <div
      class="hidden lg:flex flex-1 justify-center min-w-0 mx-2"
      [class.invisible]="!showHeaderSearch"
      [class.pointer-events-none]="!showHeaderSearch"
      [attr.aria-hidden]="!showHeaderSearch"
      [attr.inert]="showHeaderSearch ? null : ''"
      (click)="onSearchBarClick($event)"
    >
      <div
        class="flex items-center justify-between relative w-full max-w-145 2xl:w-145 gap-2 shrink-0 bg-white border border-[#EFEFF1] rounded-full"
      >
        <div class="inline-flex grow">
          <div
            class="relative inline-block border-r border-[#EFEFF1]"
          >
            <button
              type="button"
              [attr.aria-label]="'Filter by category: ' + categorySelected"
              [attr.aria-expanded]="isDropdownVisible('headerSearch')"
              aria-haspopup="listbox"
              aria-controls="header-search-panel"
              class="text-[#101010] ps-6 py-3 pe-4.5 font-Inter font-normal text-sm tracking-[-0.09px] flex items-center"
              (click)="toggleDropdown('headerSearch', $event)"
            >
              <span class="truncate max-w-17.5 me-1">{{
                categorySelected
              }}</span>
              <span>
                <img
                  src="../../../../../assets/header/icons/arrow-down.svg"
                  class="transition-transform duration-200 ms-1"
                  [ngClass]="{
                    'rotate-180': isDropdownVisible('headerSearch'),
                  }"
                  alt="arrow-down New Creative Stall"
              /></span>
            </button>
            <div
              id="header-search-panel"
              class="absolute left-0 top-12.5 w-45 overflow-hidden rounded-2xl bg-white shadow-lg ease-in-out duration-200 opacity-0 z-62"
              [ngClass]="
                isDropdownVisible('headerSearch')
                  ? 'opacity-100 translate-y-0 visible'
                  : 'translate-y-7 invisible'
              "
            >
              <ul
                class="border-b border-gray-300 py-4.5 pb- px-1.5 flex flex-col gap-2"
              >
                <li
                  class="cursor-pointer"
                  (click)="onSelectCategory('All Assets')"
                >
                  <span
                    class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA]"
                  >
                    <img
                      class="size-4.5"
                      src="../../../../../assets/theme/images/logo/following.svg"
                      alt="following icon"
                      aria-hidden="true"
                    />
                    <span
                      class="font-semibold text-sm leading-5 text-themeNero"
                      >All Assets</span
                    ></span
                  >
                </li>
                @for (item of categories; track $index) {
                  <li>
                    <a
                      [href]="getCategoryDropdownHref(item.name!)"
                      [title]="item.name"
                      (click)="onCategoryDropdownClick($event, item.name!)"
                      class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer no-underline text-inherit"
                    >
                      <img
                        class="size-4.5"
                        [src]="
                          '../../../../../assets/header/icons/' +
                          (item.menuName ?? 'default') +
                          '.svg'
                        "
                        [alt]="item.name + ' category icon'"
                      /><span
                        class="font-semibold text-sm leading-5 text-themeNero"
                        >{{ item.name }}</span
                      ></a
                    >
                  </li>
                }

                <!-- <div class="border-b border-themeBonJour my-2"></div>
                <li class="flex items-center py-2 cursor-pointer">
                  <input type="checkbox" name="" id="ai-image" class="w-[18px] h-[18px] me-2 cursor-pointer">
                  <label for="ai-image" class=" flex items-center w-full cursor-pointer">Designers</label>
                </li> -->
              </ul>
              <div class="py-4.5 px-1.5 flex flex-col gap-2">
                <div
                  role="button"
                  class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
                >
                  <input
                    [checked]="content === 'free'"
                    (click)="onSelectLicenseType('free')"
                    type="checkbox"
                    class="size-4.5 border accent-themeNero"
                    id="header-free"
                  />
                  <label
                    for="header-free"
                    class="font-semibold text-sm leading-5 text-themeNero"
                    >Free</label
                  >
                </div>
                <div
                  role="button"
                  class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
                >
                  <input
                    [checked]="content === 'pro'"
                    (click)="onSelectLicenseType('pro')"
                    type="checkbox"
                    class="size-4.5 border accent-themeNero!"
                    id="header-premium"
                  />
                  <label
                    for="header-premium"
                    class="font-semibold text-sm leading-5 text-themeNero"
                    >Pro</label
                  >
                </div>
              </div>
            </div>
          </div>

          <input
            type="search"
            aria-label="Search creative assets"
            placeholder="What are you looking for?"
            [(ngModel)]="search"
            (keyup.enter)="changeSearch($event)"
            (paste)="handlePaste($event)"
            autocomplete="off"
            maxlength="700"
            class="grow ps-3.5 py-3 text-sm font-normal text-[#767676] placeholder:text-[#767676] placeholder:font-normal focus-within:outline-none"
          />
        </div>
        <div class="inline-flex items-center gap-0">
          @if (search.trim().length >= 1) {
            <span (click)="clearSearch()" class="p-1 shrink-0 mr-2">
              <img
                src="../../../../../assets/header/icons/cross-black.svg"
                alt="cross black"
                class="cursor-pointer"
            /></span>
          }
          <button
            aria-label="Search"
            (click)="OnEnterSearch()"
            class="group flex items-center justify-center w-8 h-8 rounded-full hover:bg-black m-1 shrink-0 transition-colors duration-300"
          >
            <img
              src="../../../../../assets/header/icons/search-black.svg"
              class="size-4 block group-hover:hidden transition-opacity duration-300"
              alt="search black"
            />
            <img
              src="../../../../../assets/header/icons/search-white.svg"
              class="size-4 hidden group-hover:block transition-opacity duration-300"
              alt="search white"
            />
          </button>
          <!-- <button  class="group  flex items-center
             justify-center w-8 h-8 rounded-full hover:bg-black
             m-1 shrink-0 transition-colors duration-300">
             <img src="../../../../../assets/header/icons/gallery-black.svg"
                class="size-4 block group-hover:hidden transition-opacity duration-300"
                alt="search" />
              <img src="../../../../../assets/header/icons/gallery-white.svg"
                class="size-4 hidden group-hover:block transition-opacity duration-300"
                alt="search white" />
            </button> -->
        </div>
      </div>
    </div>
    <!------- Header Search End ------->

    <div class="flex items-center shrink-0">
      @if (!showAuthOptions) {
        <nav class="me-5 xl:block hidden">
          <ul
            class="flex items-center text-themeBlackTwo text-base font-medium gap-5"
          >
            <li class="cursor-pointer">
              <a
                [routerLink]="['/pricing']"
                (click)="onLinkClick($event)"
                class="whitespace-nowrap"
                >Pricing</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/auth/login']"
                (click)="onLinkClick($event)"
                class="whitespace-nowrap"
                >Log in</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/auth/signup']"
                (click)="onLinkClick($event)"
                class="bg-themeBlackTwo text-white font-semibold text-base rounded-full py-3 px-5 flex justify-center items-center whitespace-nowrap"
                >Create free Account</a
              >
            </li>
          </ul>
        </nav>
      }
      <div class="relative">
        @if (showAuthOptions) {
          @if (headerAvatarSrc) {
            <app-avatar
              role="button"
              tabindex="0"
              (click)="toggleDropdown('userOptionToggle', $event)"
              (keydown)="onMenuKeydown($event, 'userOptionToggle')"
              [attr.aria-expanded]="isDropdownVisible('userOptionToggle')"
              aria-haspopup="menu"
              aria-controls="user-option-panel"
              aria-label="Open account menu"
              [size]="'xs'"
              [customClass]="'!border-[#4B9F53] '"
              [userPic]="headerAvatarSrc"
            ></app-avatar>
          } @else {
            <!-- No green border while loading — border only on the ready avatar -->
            <span
              class="size-[42px] rounded-full bg-[#EFEFF1] animate-pulse shrink-0"
              aria-hidden="true"
            ></span>
          }
        } @else {
          <span
            role="button"
            tabindex="0"
            class="rounded-full flex justify-center items-center h-11 w-11 hover:bg-ThemeWhisper lg:bg-white bg-ThemeWhisper transition-colors ease-in-out duration-200 cursor-pointer"
            [ngClass]="
              isDropdownVisible('dropdown3') ? 'bg-ThemeWhisper' : ''
            "
            (click)="toggleDropdown('userOptionToggle', $event)"
            (keydown)="onMenuKeydown($event, 'userOptionToggle')"
            [attr.aria-expanded]="isDropdownVisible('userOptionToggle')"
            aria-haspopup="menu"
            aria-controls="user-option-panel"
            [attr.aria-label]="isDropdownVisible('userOptionToggle') ? 'Close menu' : 'Open menu'"
          >
            @if (isDropdownVisible('userOptionToggle')) {
              <img
                src="../../../../../assets/theme/images/icons/popup-cross-black.svg"
                class="w-3.5 h-3.5 block"
                alt="close"
              />
            } @else {
              <img
                src="../../../../../assets/theme/images/icons/menu-bar.svg"
                class="max-w-full h-auto block "
                alt="menu-bar icon"
                aria-hidden="true"
              />
            }
            <!-- <img
              src="../../../../../assets/theme/images/icons/avatar-line.svg"
              class="max-w-full h-auto lg:hidden block"
              alt="menu-bar"
            /> -->
          </span>
        }
        <div
          id="user-option-panel"
          class="lg:absolute fixed right-0 lg:top-12 top-37.5 lg:w-60 lg:max-w-60 w-full overflow-hidden lg:rounded-2xl bg-white shadow-lg ease-in-out duration-200 opacity-0 z-62"
          [ngClass]="
            isDropdownVisible('userOptionToggle')
              ? 'opacity-100 translate-y-0 visible'
              : 'translate-y-7 invisible'
          "
        >
          <app-user-detail [isUserSession]="showAuthOptions"></app-user-detail>
        </div>
      </div>
    </div>
  </div>
  <!------- Header Search mobile: collapse height instead of *ngIf to avoid layout jump ------->
  <div
    class="lg:hidden flex justify-center items-center overflow-hidden transition-[max-height,opacity,margin,padding,border-color] duration-200 ease-out"
    [ngClass]="
      showHeaderSearch
        ? 'max-h-20 opacity-100 pt-3 mt-3 px-5 border-t border-[#EFEFF1]'
        : 'max-h-0 opacity-0 pt-0 mt-0 px-5 border-t border-transparent pointer-events-none'
    "
    [attr.aria-hidden]="!showHeaderSearch"
    [attr.inert]="showHeaderSearch ? null : ''"
    (click)="onSearchBarClick($event)"
  >
    <div
      class="flex items-center justify-between relative lg:max-w-81.25 lg:w-81.25 w-full gap-2 shrink bg-white border border-[#EFEFF1] rounded-full"
    >
      <div class="inline-flex grow">
        <div
          class="relative inline-block border-r border-[#EFEFF1]"
        >
          <button
            type="button"
            [attr.aria-label]="'Filter by category: ' + categorySelected"
            [attr.aria-expanded]="isDropdownVisible('headerSearch')"
            aria-haspopup="listbox"
            aria-controls="header-search-panel-mobile"
            class="text-[#101010] ps-3 py-3.5 pe-2 font-Inter font-normal text-sm tracking-[-0.09px] flex items-center"
            (click)="toggleDropdown('headerSearch', $event)"
          >
            <span class="truncate max-w-17.5 me-1">{{
              categorySelected
            }}</span>
            <span>
              <img
                src="../../../../../assets/header/icons/arrow-down.svg"
                class="transition-transform duration-200 ms-1"
                [ngClass]="{
                  'rotate-180': isDropdownVisible('headerSearch'),
                }"
                alt="arrow-down Next Creative Stall"
            /></span>
          </button>
          <div
            id="header-search-panel-mobile"
            class="absolute left-0 top-12.5 w-45 overflow-hidden rounded-2xl bg-white shadow-lg ease-in-out duration-200 opacity-0 z-50"
            [ngClass]="
              isDropdownVisible('headerSearch')
                ? 'opacity-100 translate-y-0 visible'
                : 'translate-y-7 invisible'
            "
          >
            <ul
              class="border-b border-[#0000000D pt-4.5 pb- px-1.5 flex flex-col gap-2"
            >
              <li
                class="cursor-pointer"
                (click)="onSelectCategory('All Assets')"
              >
                <span
                  class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA]"
                >
                  <img
                    class="size-4.5"
                    src="../../../../../assets/theme/images/logo/following.svg"
                    alt="following icon"
                    aria-hidden="true"
                  />
                  <span
                    class="font-semibold text-sm leading-5 text-themeNero"
                    >All Assets</span
                  ></span
                >
              </li>
              @for (item of categories; track $index) {
                <li>
                  <a
                    [href]="getCategoryDropdownHref(item.name!)"
                    [title]="item.name"
                    (click)="onCategoryDropdownClick($event, item.name!)"
                    class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer no-underline text-inherit"
                  >
                    <img
                      class="size-4.5"
                      [src]="
                        '../../../../../assets/header/icons/' +
                        (item.menuName ?? 'default') +
                        '.svg'
                      "
                      [alt]="item.name + ' category icon'"
                    /><span
                      class="font-semibold text-sm leading-5 text-themeNero"
                      >{{ item.name }}</span
                    ></a
                  >
                </li>
              }

              <!-- <div class="border-b border-themeBonJour my-2"></div>
                <li class="flex items-center py-2 cursor-pointer">
                  <input type="checkbox" name="" id="ai-image" class="w-[18px] h-[18px] me-2 cursor-pointer">
                  <label for="ai-image" class=" flex items-center w-full cursor-pointer">Designers</label>
                </li> -->
            </ul>
            <div class="py-4.5 px-1.5 flex flex-col gap-2">
              <div
                role="button"
                class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
              >
                <input
                  [checked]="content === 'free'"
                  (click)="onSelectLicenseType('free')"
                  type="checkbox"
                  class="size-4.5 border accent-themeNero"
                  id="header-mobile-free"
                />
                <label
                  for="header-mobile-free"
                  class="font-semibold text-sm leading-5 text-themeNero"
                  >Free</label
                >
              </div>
              <div
                role="button"
                class="flex items-center gap-2.5 py-2.5 px-2.5 hover:bg-[#F9FAFA] cursor-pointer"
              >
                <input
                  [checked]="content === 'pro'"
                  (click)="onSelectLicenseType('pro')"
                  type="checkbox"
                  class="size-4.5 border accent-themeNero!"
                  id="header-mobile-premium"
                />
                <label
                  for="header-mobile-premium"
                  class="font-semibold text-sm leading-5 text-themeNero"
                  >Pro</label
                >
              </div>
            </div>
          </div>
        </div>

        <input
          type="search"
          aria-label="Search creative assets"
          placeholder="What are you looking for?"
          [(ngModel)]="search"
          (keyup.enter)="changeSearch($event)"
          (paste)="handlePaste($event)"
          autocomplete="off"
          maxlength="700"
          class="grow ps-3 py-3.5 text-xs font-normal text-[#767676] placeholder:text-[#767676] placeholder:font-normal focus-within:outline-none"
        />
      </div>
      <div class="inline-flex items-center gap-0 pe-3">
        @if (search.trim().length >= 1) {
          <span (click)="clearSearch()" class="p-1 shrink-0 mr-1">
            <img
              src="../../../../../assets/header/icons/cross-black.svg"
              class="cursor-pointer"
              alt="cross black"
          /></span>
        }
        <button
          aria-label="Search"
          (click)="OnEnterSearch()"
          class="group flex items-center justify-center w-4 h-4 rounded-full hover:bg-black m-1 shrink-0 transition-colors duration-300"
        >
          <img
            src="../../../../../assets/header/icons/search-black.svg"
            class="size-3.5 block group-hover:hidden transition-opacity duration-300"
            alt="search black"
          />
          <img
            src="../../../../../assets/header/icons/search-white.svg"
            class="size-3.5 hidden group-hover:block transition-opacity duration-300"
            alt="search white"
          />
        </button>
        <!-- <button  class="group  flex items-center
             justify-center w-4 h-4 rounded-full hover:bg-black
             m-1 shrink-0 transition-colors duration-300">
             <img src="../../../../../assets/header/icons/gallery-black.svg"
                class="size-3.5 block group-hover:hidden transition-opacity duration-300"
                alt="search" />
              <img src="../../../../../assets/header/icons/gallery-white.svg"
                class="size-3.5 hidden group-hover:block transition-opacity duration-300"
                alt="search white" />
            </button> -->
      </div>
    </div>
  </div>
  <!------- Header Search mobile End ------->
</header>
<!-- @if(isOverlay){
<div class="fixed h-screen top-[75px] w-full bg-[#0000007a] lg:hidden block"
  (click)="onLinkClick($event)" [ngClass]="isOverlay ? 'text-opacity-100 ' : 'opacity-0'"></div>
} -->
<!-- @if(!isLandingPageRoute()){
    } -->
